import React from "react";
import { array, func, object } from "prop-types";
import { Link } from "@quintype/components";
import { connect } from "react-redux";
import get from "lodash/get";

import CardImage from "../../atoms/CardImage";
import Headline from "../../atoms/Headline";
import { staticTexts } from "../../utils/Translate";

import "./bookmarksPopup.m.css";

const BookmarksPopup = ({ stories, navigateToPage, publisherAttributes }) => (
  <div styleName="container">
    <div styleName="read-wrapper" onClick={() => navigateToPage("/saved")}>
      <span styleName="later-reading">{staticTexts(publisherAttributes.lang).saveToReadLater}</span>
      <span styleName="nav-right">&gt;</span>
    </div>
    <div styleName="stories">
      {stories.slice(0, 3).map((item, index) => (
        <Link key={index} href={item.url}>
          <div styleName="item">
            <Headline text={item.headline} headerLevel={3} headlineType={6} />
            <CardImage story={item} aspectRatio={[1, 1]} imageType="image1x1" widths={[60]} showAlternateImage={true} />
          </div>
        </Link>
      ))}
    </div>
  </div>
);

BookmarksPopup.propTypes = {
  stories: array.isRequired,
  navigateToPage: func,
  publisherAttributes: object
};

const mapStateToProps = state => {
  return {
    publisherAttributes: get(state, ["qt", "config", "publisher-attributes"], {})
  };
};

export default connect(mapStateToProps, null)(BookmarksPopup);
